import { render, staticRenderFns } from "./expenses-module.vue?vue&type=template&id=58d5248a"
import script from "./expenses-module.vue?vue&type=script&lang=js"
export * from "./expenses-module.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports